<template lang="pug">
    v-layout.justify-content(row wrap)
        v-flex(xs12)
            Navbar
        responsive-flex
            //- Loader
            v-flex.wf-mx-auto.mt-3
                h2#payments-heading Welcome to your Payments Center
                .caption On this screen you can view the status of your active EasyLinks.

                //EasyPay Modal
                EasyPayDialog.mt-3(
                    @easyPayLinkSent="refreshPaymentLinksList"
                )
                
                //Payments Links
                PaymentLinksList(
                    v-if="showPaymentsLinksList"
                )
            
                
</template>

<script>
    import EasyPayDialog from '@/components/EasyPayDialog'
    import Navbar from 'Components/Navbar.vue'
    import PaymentLinksList from 'Components/PaymentLinksList.vue'
    import ResponsiveFlex from 'Components/ResponsiveFlex.vue'

    export default {
        name: 'my-payments-view', 
        components: {
            EasyPayDialog,
            Navbar,
            PaymentLinksList,
            ResponsiveFlex
        },
        data() {
            return {
                paymentImg: require('../assets/money_ac.svg'),
                showPaymentsLinksList: true,
            }
        },
        methods: {
            refreshPaymentLinksList() {
                this.showPaymentsLinksList = false
                this.$nextTick(() => {
                    this.showPaymentsLinksList = true
                })
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>